import { ViewEncapsulation, Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/shared/global.service";
import { UrlService } from "src/app/shared/services/url.service";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/shared/services/alert.service";
import { Router } from "@angular/router";
import { UtilService } from "src/app/shared/services/util.service";
import { UrlControl } from "src/app/shared/models/generic.model";
import { ConstantesService } from "src/app/shared/services/constantes.service";
import { ConfirmationModalOptions } from "src/app/shared/models/modal.model";
import { DominiosService } from "src/app/shared/services/dominios.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { AgendaComponent } from "../agenda/agenda.component";
import * as moment from "moment";

declare var $: any;
@Component({
  selector: "app-solicitar-turno",
  templateUrl: "./solicitar-turno.template.html",
  styleUrls: ["./solicitar-turno.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

/**
 * @author jnmartinez
 */
export class SolicitarTurnoComponent implements OnInit {
  documentos: any[] = [];
  tramites: any[] = [];
  sedes: any[] = [];
  generos: any[] = [];
  motivoPrioridad: any[] = [];
  tipoDiscapacidad: any[] = [];
  modalConfirmMessage: ConfirmationModalOptions;
  parametros: string[] = [DominiosService.SEDE_POR_DEFECTO];

  visitante: any;
  ciudadano: any;
  agenda: any;
  prioridad = false;
  isDiscapacidad = false;
  correoInvalido = false;
  motivosXTramite = [];
  motivosUAC = [];
  sedesXTramite = [];
  constructor(
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private utils: UtilService,
    public router: Router,
    private modalService: NgbModal
  ) { }
  // tslint:disable: triple-equals
  ngOnInit() {
    this.visitante = {};
    this.agenda = {};
    this.visitante.numDocVisitante = sessionStorage.getItem(
      ConstantesService.NUM_DOC_SESSSION
    );
    this.visitante.tipoDocVisitante = sessionStorage.getItem(
      ConstantesService.TIPO_DOC_SESSSION
    );

    if (
      !this.utils.validarCamposObligatorios(this.visitante.numDocVisitante) &&
      !this.utils.validarCamposObligatorios(this.visitante.tipoDocVisitante)
    ) {
      this.router.navigate(["/agenda-virtual"]);
    }

    this.modalConfirmMessage = new ConfirmationModalOptions(
      "Confirmación asignación de turno",
      "¿Está seguro de solicitar turno virtual?",
      "Si",
      "No",
      "fas fa-save",
      false,
      false,
      "Solicitar turno",
      false,
      "btn-secondary btn-solicitud"
    );

    this.consultarPersona();
    this.obtenerDominio("Sede", "sedes");
    this.obtenerDominio("Genero", "generos");
    this.obtenerDominio("TipoDiscapacidad", "tipoDiscapacidad");
    this.obtenerDominio("MotivoPrioridad", "motivoPrioridad");
    this.obtenerDominio("TipoIdentificacion", "documentos");
    this.consultarTramites();
  }


	async consultarMotivosXTramite() {
		try {
		this.spinner.show();
		const serviceProvider = 'motivosTramiteUAC';
		const pathParams: Array<[string, string]> = new Array<[string, string]>();
		pathParams.push([
		"filterBy=idTramite",
		this.agenda.tramite,
		]);
		pathParams.push([
		"estado",
		"ACT",
		]);
		let url = this.urlService.getUrlUAC(
		new UrlControl(serviceProvider, pathParams, null),
		this.urlService.hostAPI_UAC
		);		
		let data = await this.global.getPublico(url).toPromise();
		await this.consultarMotivosUAC();
		//Extrayendo la descripción del motivo
		for( let d1 of data.filter(f=>f.estado==='ACT') ){			
			for( let d2 of this.motivosUAC ){				
				if(d1.motivoConsulta == d2.id){
					d1.motivoConsultaDesc = d2.descripcion;					
					break;
				}				
			}
		}		
		this.motivosXTramite = data.filter(f=>f.estado==='ACT' && f.motivoConsultaDesc);
		console.log("== consultarMotivosXTramite ==")
		console.log(this.motivosXTramite);
		console.log("==");
		if (this.motivosXTramite.length == 0)
		this.agenda.idMotivoConsulta = undefined;
		// this.cargarMotivosXTramite();
		} catch (error) {
		this.catchException('No fue posible Cargar los motivos por tramite');
		} finally {
		this.spinner.hide();
		}
	}
  
	async consultarMotivosUAC() {
		try {
		  this.spinner.show();
		  const serviceProvider = 'consultarMotivoUAC';
		  const pathParams: Array<[string, string]> = new Array<[string, string]>();
		  pathParams.push([
			"estado",
			"ACT",
		  ]);
		  let url = this.urlService.getUrlUAC(
			new UrlControl(serviceProvider, pathParams, null),
			this.urlService.hostAPI_UAC
		  );
		  let data = await this.global.getPublico(url).toPromise();		  
		  //console.log(data);		  
		  this.motivosUAC = data.filter(f=>f.estado ==='ACT');
		  /*
		  if (this.motivosXTramite.length == 0)
			this.agenda.idMotivoConsulta = undefined;
		  // this.cargarMotivosXTramite();
		  */
		} catch (error) {
		  this.catchException('No fue posible Cargar los motivos');
		} finally {
		  this.spinner.hide();
		}
	}

  getNombreSede(sede) {
    let sedeActual = this.sedes.filter(x => x.detalleDominioPK.nombreDetalleDominio == sede)
    if (sedeActual.length > 0)
      return sedeActual[0].valor;
  }

  async consultarSedesXTramite() {
    try {
      this.spinner.show();
      const serviceProvider = 'sedesTramiteUAC';
      const pathParams: Array<[string, string]> = new Array<[string, string]>();
      pathParams.push([
        "idTramite",
        this.agenda.tramite,
      ]);
      let url = this.urlService.getUrlUAC(
        new UrlControl(serviceProvider, pathParams, null),
        this.urlService.hostAPI_UAC
      );
      let data = await this.global.getPublico(url).toPromise();
      this.sedesXTramite = data;

      if (this.sedesXTramite.length == 0)
        this.agenda.sede = undefined;

      let sedeDefault = this.sedesXTramite.filter(x => x.isDefault == 1);
      if (sedeDefault.length > 0) {
        this.agenda.sede = sedeDefault[0].sedesTramitesUACPK.sede;

      }

    } catch (error) {
      this.catchException('No fue posible Cargar las Sedes por tramite');
    } finally {
      this.spinner.hide();
    }
  }


  /**
      *
      */
  catchException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
  /**
   * Método que obtiene los datos del ciudadano si existen
   * @author jnmartinez
   */
  public consultarPersona() {
    const serviceProvider = "ObtenerVisitante";
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push([
      "filterBy=visitantePK.numDocVisitante",
      this.visitante.numDocVisitante,
    ]);
    pathParams.push([
      "visitantePK.tipoDocVisitante",
      this.visitante.tipoDocVisitante,
    ]);
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, pathParams, null),
      this.urlService.hostAPI_UAC
    );
    this.global.getPublico(url).subscribe(
      (data) => {
        const infoPersona = data;
        if (infoPersona.length > 0) {
          this.visitante.correoVisitante = infoPersona[0].correoVisitante;
          this.visitante.nombreCompleto = infoPersona[0].nombreCompleto;
          this.visitante.primerNombre = infoPersona[0].primerNombre;
          this.visitante.segundoNombre = infoPersona[0].segundoNombre;
          this.visitante.primerApellido = infoPersona[0].primerApellido;
          this.visitante.segundoApellido = infoPersona[0].segundoApellido;
          this.procesarNombre();

          this.visitante.telefono = infoPersona[0].telefono;
          this.visitante.genero = infoPersona[0].genero;
        } else {
          this.alertService.generateAlertError(
            "Apreciado(a) ciudadano(a) le informamos que el documento ingresado no se encuentra registrado en el sistema",
            ""
          );
        }
      },
      (err) => {
        this.utils.cathException(
          "Se presentó un problema al consultar los datos del ciudadano",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  private procesarNombre() {
    this.visitante.nombres =
      (this.visitante.primerNombre ? this.visitante.primerNombre : "") +
      (this.visitante.segundoNombre ? " " + this.visitante.segundoNombre : "");
    this.visitante.apellidos =
      (this.visitante.primerApellido ? this.visitante.primerApellido : "") +
      (this.visitante.segundoApellido
        ? " " + this.visitante.segundoApellido
        : "");
  }

  /**
   * Método que valida si se diligencio la sede para iniciar el proceso de busqueda de
   * @author jnmartinez
   */
  public obtenerAgenda() {
    if (this.agenda.tramite) {
      if (this.agenda.sede) {
        const modalRef = this.modalService.open(AgendaComponent, {
          centered: true,
          size: "lg",
        });
        modalRef.componentInstance.agenda = this.agenda;
        modalRef.componentInstance.agenda.tipoDocVisitante =
          this.visitante.tipoDocVisitante;
        modalRef.componentInstance.agenda.numDocVisitante =
          this.visitante.numDocVisitante;

        modalRef.result.then(
          (result) => {
            if (result && result.fechaInicio) {
              let diff: number = moment(result.fechaInicio).diff(
                moment(new Date()),
                "minutes"
              );
              //console.log(diff);
              if (diff > 0) {
                this.agenda.fechaInicio = result.fechaInicio;
                this.agenda.fechaFin = result.fechaFin;
              } else {
                this.utils.cathException(
                  "No es posible agendar un turno con fecha anterior a la actual",
                  this.alertService,
                  this.spinner
                );
              }
            }
          },
          (reason) => {
            if (
              reason === ModalDismissReasons.ESC ||
              reason === ModalDismissReasons.BACKDROP_CLICK
            ) {
            }
          }
        );
      }
    } else {
      this.alertService.generateAlertInfo("Debe seleccionar un servicio", "");
    }
  }

  /**
   * Consulta de dominios
   * @param filtro indica el nombre del dominio a consultar
   * @param lista indica la lista en la que se almacena el resultado
   * @return void
   */
  public obtenerDominio(filtro, lista) {
    this.spinner.show();
    const serviceProvider = "ObtenerDominio";
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(["filterBy=detalleDominioPK.nombreDominio", filtro]);
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_TRANS
    );
    this.global.getPublico(url).subscribe(
      (data) => {
        this[lista] = data;
        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(
          "No es posible los valores inciales de la aplicación",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  private consultarParametros() {
    const serviceProvider = "consultarParametros";
    const url = this.urlService.getUrlTransversal(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_TRANS
    );
    this.global.postPublico(url, this.parametros).subscribe((data) => {
      this.agenda.sede = data[0].valor;
    });
  }

  /**
   * Método que obtiene el listado de servicios disponibles
   * @author jnmartinez
   */
  public consultarTramites() {
    this.spinner.show();
    const serviceProvider = "tramiteUAC";
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push([
      "filterBy=estado",
      ConstantesService.ESTADO_TRAMITE_ACTIVO,
    ]);
    let url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, pathParams, null),
      this.urlService.hostAPI_UAC
    );
    url = url + "&orderBy=nombre$ASC";
    this.global.getPublico(url).subscribe(
      (data: any[]) => {
        
        //Angel Campillo
        const letrasExcluidas = ['AP', 'AF'];

        this.tramites = data.filter(tramite => !letrasExcluidas.includes(tramite.letraTurno));
       
       // this.tramites = data.filter((tramite) => tramite.letraTurno != "AF");

        this.spinner.hide();
      },
      (err) => {
        this.utils.cathException(
          "Ocurrio un error en la consulta de los servicios",
          this.alertService,
          this.spinner
        );
      }
    );
  }

  /**
   * Método que valida si la agenda tiene prioridad o no
   * y reinicia los filtros dependientes
   * @author jnmartinez
   */
  validarPrioridad() {
    if (!this.prioridad) {
      this.agenda.motivoPrioridad = undefined;
      this.agenda.tipoDiscapacidad = undefined;
      this.isDiscapacidad = false;
    }
  }

  /**
   * Método que valida si la prioridad de la agenda es discapacidad fisica
   * @author jnmartinez
   */
  validarMotivo() {
    if (
      this.agenda.motivoPrioridad ==
      DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD
    ) {
      this.isDiscapacidad = true;
    } else {
      this.isDiscapacidad = false;
      this.agenda.tipoDiscapacidad = undefined;
    }
  }

  /**
   * Método que obtiene la respuesta de la confirmación del modal
   * @param event respuesta del modal
   * @author jnmartinez
   */
  getConfirmationModal(event) {
    if (event[0]) {
      this.registrarSolicitud();
    }
  }

  /**
   * Método que realiza el proceso
   * @author jnmartinez
   */
  public solicitarTurno() {
    if (!this.validarCampos()) {
      this.alertService.generateAlertError(
        "Diligenciar la información requerida",
        ""
      );
    } else {
      this.ciudadano = this.visitante;
      this.ciudadano.visitantePK = {};
      this.ciudadano.visitantePK.numDocVisitante =
        this.ciudadano.numDocVisitante;
      this.ciudadano.visitantePK.tipoDocVisitante =
        this.ciudadano.tipoDocVisitante;
      this.visitante.agenda = this.agenda;
      this.validarSolicitudTurno();
    }
  }

  convertirNombresVisitante() {
    const nombresSeparados = this.utils.separarString(
      this.visitante.nombres.trim()
    );
    const apellidosSeparados = this.utils.separarString(
      this.visitante.apellidos.trim()
    );
    this.visitante.nombreCompleto =
      this.visitante.nombres.trim() + " " + this.visitante.apellidos.trim();
    this.visitante.primerNombre = nombresSeparados[0];
    this.visitante.segundoNombre = nombresSeparados[1]
      ? nombresSeparados[1].trim()
      : nombresSeparados[1];
    this.visitante.primerApellido = apellidosSeparados[0];
    this.visitante.segundoApellido = apellidosSeparados[1]
      ? apellidosSeparados[1].trim()
      : apellidosSeparados[1];
  }

  /**
   * @author jnmartinez
   */
  public validarSolicitudTurno() {
    this.spinner.show();
    const serviceProvider = "validarSolicitudTurno";
    this.convertirNombresVisitante();
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_UAC
    );
    this.global.postPublico(url, this.ciudadano).subscribe(
      (data) => {
        $(".btn-solicitud").click();
        this.spinner.hide();
      },
      (err) => {
        if (err.error && err.error.message) {
          this.utils.cathException(err, this.alertService, this.spinner);
        } else {
          this.utils.cathException(
            "Se presentó un error al realizar las validaciones de la agenda",
            this.alertService,
            this.spinner
          );
        }
      }
    );
  }

  /**
   * Método que realiza el registro de la solicitud de turno virtual
   * @author jnmartinez
   */
  public registrarSolicitud() {
    this.spinner.show();
    const serviceProvider = "solicitudTurno";
    this.convertirNombresVisitante();
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_UAC
    );
    this.global.postPublico(url, this.ciudadano).subscribe(
      (data) => {
        this.alertService.generateAlertSuccess(
          "El turno virtual se ha creado exitosamente",
          ""
        );
        if (
          DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD ==
          this.agenda.motivoPrioridad &&
          DominiosService.TIPO_DISCAPACIDAD_MOTORA ==
          this.agenda.tipoDiscapacidad
        ) {
          this.alertService.generateAlertInfo(
            "Por favor, para su facilidad ingresar por el acceso al parqueadero",
            ""
          );
        }
        this.spinner.hide();
        this.router.navigate(["agenda-virtual"]);
      },
      (err) => {
        this.utils.cathException(err, this.alertService, this.spinner);
      }
    );
  }

  /**
   * Método que valida la completitud de datos del formulario
   * @author jnmartinez
   */
  public validarCampos() {
    return (
      this.validarCampo(this.visitante.nombres) &&
        this.validarCampo(this.visitante.apellidos) &&
        this.validarCampo(this.visitante.genero) &&
        this.validarCampo(this.visitante.telefono) &&
        this.validarCampo(this.visitante.correoVisitante) &&
        !this.correoInvalido &&
        this.validarCampo(this.agenda.tramite) &&
        this.validarCampo(this.agenda.sede) &&
        this.validarCampo(this.agenda.fechaInicio) &&
        this.validarCampo(this.agenda.fechaFin) &&
        this.motivosXTramite.length > 0 ? this.validarCampo(this.agenda.idMotivoConsulta) : true &&
          this.agenda.idMotivoConsulta == "Otro" ? this.validarCampo(this.agenda.otroMotivo) : true &&
      (!this.prioridad ||
        (this.validarCampo(this.agenda.motivoPrioridad) &&
          (this.agenda.motivoPrioridad !=
            DominiosService.MOTIVO_PRIORIDAD_DISCAPACIDAD ||
            this.validarCampo(this.agenda.tipoDiscapacidad))))
    );
  }

  public validarCampo(campo) {
    return this.utils.validarCamposObligatorios(campo);
  }

  /**
   * Método que valida si el correo ingresado es valido
   * @author jnmartinez
   */
  validarCorreo() {
    this.correoInvalido = this.utils.validarCorreo(
      this.visitante.correoVisitante
    );
  }

  regresarConsulta() {
    sessionStorage.removeItem(ConstantesService.NUM_DOC_SESSSION);
    sessionStorage.removeItem(ConstantesService.TIPO_DOC_SESSSION);
    this.router.navigate(["agenda-virtual"]);
  }

  async limpiarAgenda() {
    this.agenda.fechaInicio = null;
    await this.consultarMotivosXTramite();	
    await this.consultarSedesXTramite();
    // this.consultarParametros();
  }
}
